import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useQuery, useLazyQuery } from "react-apollo";

import { Field, Control, Label, Input } from "rbx";

import moment from "moment";

import gql from "graphql-tag";

const ALL_SYSTEM_CODES_QUERY = gql`
  query ALL_SYSTEM_CODES_QUERY($where: SystemCodeWhereInput) {
    SystemCodes(where: $where) {
      RecId
    }
  }
`;
const ALL_BOOKINGS_QUERY = gql`
  query ALL_BOOKINGS_QUERY($where: BookingWhereInput) {
    Bookings(where: $where) {
      RecId
    }
  }
`;

const ALL_BOOKING_CODES_QUERY = gql`
  query ALL_BOOKING_CODES_QUERY($where: BookingCodeWhereInput) {
    BookingCodes(where: $where) {
      RecId
    }
  }
`;

const DaysUsed = ({
  employeeRecId,
  startDate,
  endDate,
  daysAllowed,
  showBalance,
  type
}) => {
  const [daysUsed, setDaysUsed] = useState(0);
  const [daysUsedAdjustment, setDaysUsedAdjustment] = useState(0);

  const { data: SystemCodesData } = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {
        Category: "BookingCodes",
        CodeName: "BookCatg",
        CodeId: "NA-PTO"
      }
    }
  });

  const [getBookingCodes, { data: BookingCodesData }] = useLazyQuery(
    ALL_BOOKING_CODES_QUERY
  );
  const [
    getReverseBookingCodes,
    { data: ReverseBookingCodesData }
  ] = useLazyQuery(ALL_BOOKING_CODES_QUERY);

  useEffect(() => {
    const systemCodes = SystemCodesData?.SystemCodes;
    if (Array.isArray(systemCodes) && systemCodes[0]) {
      getBookingCodes({
        variables: {
          where: {
            CodeCatgRecIdRef: systemCodes[0].RecId,
            BookingCode: type === "vacation" ? "NA13" : "NA10"
          }
        }
      });
      getReverseBookingCodes({
        variables: {
          where: {
            CodeCatgRecIdRef: systemCodes[0].RecId,
            BookingCode: type === "vacation" ? "NA13-R" : "NA10-R"
          }
        }
      });
    }
  }, [SystemCodesData, getBookingCodes, getReverseBookingCodes, type]);

  const [getBookings, { data: BookingsData }] = useLazyQuery(
    ALL_BOOKINGS_QUERY
  );
  const [getReverseBookings, { data: ReverseBookingsData }] = useLazyQuery(
    ALL_BOOKINGS_QUERY
  );

  useEffect(() => {
    const bookings = BookingsData?.Bookings;
    if (Array.isArray(bookings)) {
      setDaysUsed(bookings.length);
    }
  }, [BookingsData]);

  useEffect(() => {
    const bookings = ReverseBookingsData?.Bookings;
    if (Array.isArray(bookings)) {
      setDaysUsedAdjustment(bookings.length);
    }
  }, [ReverseBookingsData]);

  useEffect(() => {
    const bookingCodes = BookingCodesData?.BookingCodes;
    if (employeeRecId && startDate && endDate && Array.isArray(bookingCodes)) {
      getBookings({
        variables: {
          where: {
            EmployeeRecIdRef: parseInt(employeeRecId, 10),
            PickupDate_gte: moment(startDate).startOf("day"),
            PickupDate_lte: moment(endDate).endOf("day"),
            BookingCodeRecIdRef_in: bookingCodes.map(x => x.RecId)
          }
        }
      });
    }
  }, [BookingCodesData, employeeRecId, endDate, getBookings, startDate]);

  useEffect(() => {
    const bookingCodes = ReverseBookingCodesData?.BookingCodes;
    if (employeeRecId && startDate && endDate && Array.isArray(bookingCodes)) {
      getReverseBookings({
        variables: {
          where: {
            EmployeeRecIdRef: parseInt(employeeRecId, 10),
            PickupDate_gte: moment(startDate).startOf("day"),
            PickupDate_lte: moment(endDate).endOf("day"),
            BookingCodeRecIdRef_in: bookingCodes.map(x => x.RecId)
          }
        }
      });
    }
  }, [
    ReverseBookingCodesData,
    employeeRecId,
    endDate,
    getReverseBookings,
    startDate
  ]);

  return (
    <Field kind="group">
      <Control expanded>
        <Label>Days Used</Label>
        <Input
          readOnly
          autocomplete="new"
          type="number"
          value={daysUsed - daysUsedAdjustment}
        />
      </Control>
      {showBalance && (
        <Control expanded>
          <Label>Balance</Label>
          <Input
            readOnly
            type="number"
            value={daysAllowed - (daysUsed - daysUsedAdjustment)}
          />
        </Control>
      )}
    </Field>
  );
};

DaysUsed.propTypes = {
  employeeRecId: PropTypes.number.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  daysAllowed: PropTypes.number,
  showBalance: PropTypes.bool,
  type: PropTypes.string
};
DaysUsed.defaultProps = {
  startDate: new Date(),
  endDate: new Date(),
  daysAllowed: 0,
  showBalance: false,
  type: "vacation"
};

export default DaysUsed;
